//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { AttendanceStatus } from './Enums';

export class AttendanceSearchOptions extends ItemBase {
    StartDate: string | null = null;
    EndDate: string | null = null;
    EventIDs: string[] = [];
    EventSeriesIDs: string | null = null;
    EventCategoryIDs: string[] = [];
    OriginalTeacherIDs: string[] = [];
    StudentIDs: string[] = [];
    TeacherIDs: string[] = [];
    HasVisibleLessonNotes: boolean | null = null;
    Statuses: AttendanceStatus[] = [];
    IDs: string[] = [];
    StartTime: string | null = null;
    EndTime: string | null = null;
    HasAttachments: boolean | null = null;

    constructor(initializer?: Partial<AttendanceSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "AttendanceSearchOptions";
}
